// ============================================================
// หน้า Export — รายชื่อลูกค้า (หน้าเก่า)
// ------------------------------------------------------------
// ⚠️ หมายเหตุ (ยกมาตามพฤติกรรมเดิม ยังไม่ได้แก้)
//   - หน้านี้ซ้ำกับหน้า Customer เกือบทั้งหมด และไม่มีในเมนู (เข้าได้ทาง URL /export เท่านั้น)
//     เมนู "export" ใน components/global.js ถูก comment ปิดไว้
//   - แถวสรุปหัวตาราง (หน่วยก่อสร้าง 1052 / โอนแล้ว 717 / ยังไม่โอน 335 / ห้องว่าง 1)
//     เป็นตัวเลข hardcode ไม่ได้คำนวณจากข้อมูลจริง
//   - สิทธิ์ที่เช็คคือเมนู "record-water-usage" ไม่ใช่ "customer"
//   ถ้ายืนยันว่าไม่ได้ใช้แล้ว แนะนำให้ลบทั้งหน้าออกพร้อม route
// ============================================================

import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import Select from "react-select";
import { ReactExcel, readFile, generateObjects } from "@ramonak/react-excel";

import "../../shared/config/global.js";
import "../../assets/css/bootstrap.css";
import Navbar from "../../shared/layout/Navbar.js";
import excel_file from "../../assets/files/import_customer.xlsx";
import {
  loading,
  tokens,
  select_style,
  success,
  GET,
  POST,
  PUT,
  DELETE,
  format_date,
  number,
  float,
  required,
  DatePicker,
  getStorage,
  permission,
  Paginate,
  ActionIcon,
  ExcelDropZone,
  ICON,
} from "../../shared/index.js";
import { TRANSFER_FROM_TEXT, BUY_FROM_TEXT } from "../../shared/domain/customer-excel.js";
import { report_customer_1 } from "../../documents/builders/ReportCustomer01.js";
import { report_customer_2 } from "../../documents/builders/ReportCustomer02.js";
import { report_customer_3 } from "../../documents/builders/ReportCustomer03.js";

// สิทธิ์ที่หน้านี้เช็ค (ตามของเดิม — ใช้เมนูข้อมูลการใช้น้ำ ไม่ใช่เมนูลูกค้า)
const perm = permission("record-water-usage");

const STAT_TRANS = [
  { value: 1, label: "โอนกรรมสิทธิ์แล้ว" },
  { value: 2, label: "ยังไม่โอนกรรมสิทธิ์" },
  { value: 3, label: "ห้องว่าง" },
];
const STAT_BUY = [
  { value: 1, label: "เงินสด" },
  { value: 2, label: "ผ่อนชำระกับธนาคาร" },
  { value: 3, label: "ผู้เช่าซื้อกับการเคหะแห่งชาติ" },
  { value: 4, label: "ซื้อต่อกับลูกค้าเดิม" },
  { value: 5, label: "อื่น ๆ" },
];

// สีป้ายสถานะการโอนในตาราง
const TRANSFER_COLOR = { 1: "bg-primary", 2: "bg-purple", 3: "bg-blue" };

// หัวคอลัมน์ตารางตรวจสอบก่อนนำเข้า
const PREVIEW_HEADERS = [
  "ชื่อ - สกุล",
  "เลขบัตรประชาชน",
  "ที่อยู่",
  "โทรศัพท์บ้าน",
  "โทรศัพท์มือถือ",
  "วันที่ส่งมอบ",
  "วันที่มารับมอบ",
  "วันที่โอน",
  "สถานะการโอน",
  "เลขที่เงินกู้",
  "วงเงินกู้",
  "เงินงวด",
  "วันที่ทำสัญญา",
  "ซื้ออาคารโดย",
  "อาคาร",
  "ชั้น",
  "บ้านเลขที่",
  "ขนาดห้อง (ตรม.)",
  "ลบ",
];

const initialForm = {
  customer_id: "",
  full_name: "",
  id_card: "",
  address: "",
  home_phone: "",
  mobile_phone: "",
  delivery_date: "",
  receive_date: "",
  transfer_date: "",
  status_transfer: null,
  loan_number: "",
  credit_limit: "",
  installment: "",
  contract_date: "",
  status_buy_building: null,
  address_number: "",
  building: "",
  floor: "",
  room_size: "",
};

// หา label จากรหัสที่เก็บใน DB
const labelOf = (opts, value) => opts.find((o) => o.value === value)?.label || "-";

export default class Export extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_create: false,
      modal_update: false,
      modal_delete: false,
      modal_import: false,
      page: 1,
      filter_data_search: "",
      filter_transfer_date: "",
      filter_status_transfer: null,
      data: null,
      file_import: null,
      currentSheet: null,
      data_import: null,
      form: { ...initialForm },
    };
  }

  async componentDidMount() {
    loading(false);
    if (perm.view) await this.GetAll();
  }

  // ---------- เรียกข้อมูล ----------

  GetAll = async () => {
    loading(true);
    const { filter_data_search, filter_transfer_date, filter_status_transfer, page } = this.state;
    const body = {
      data_search: filter_data_search,
      transfer_date: filter_transfer_date,
      status_transfer: filter_status_transfer?.value || "",
    };
    const result = await GET(tokens, "v1/TH/customer-manage/filter-search/page/" + page + "/" + getStorage("project_id"), body);
    if (result?.status) this.setState({ data: result.data });
    loading(false);
  };

  // ---------- บันทึก / ลบ ----------

  // แปลงฟอร์มเป็นรูปที่ backend รับ
  getPayload = () => {
    const { form } = this.state;
    return {
      ...form,
      credit_limit: parseFloat(form.credit_limit) || 0,
      installment: parseFloat(form.installment) || 0,
      status_transfer: form.status_transfer?.value || "",
      status_buy_building: form.status_buy_building?.value || "",
      floor: Number(form.floor) || 0,
      room_size: Number(form.room_size) || 0,
    };
  };

  // บันทึกสำเร็จแล้วทำเหมือนกันทุกกรณี: ล้างฟอร์ม แจ้งสำเร็จ โหลดข้อมูลใหม่
  afterSave = (result) => {
    if (result?.status) {
      this.clear_form();
      success();
      this.GetAll();
    }
    loading(false);
  };

  Create = async () => {
    loading(true);
    this.afterSave(await POST(tokens, "v1/TH/customer-manage/create/" + getStorage("project_id"), { customer_list: [this.getPayload()] }));
  };

  Update = async () => {
    loading(true);
    this.afterSave(await PUT(tokens, "v1/TH/customer-manage/update", this.getPayload()));
  };

  Delete = async () => {
    loading(true);
    this.afterSave(await DELETE(tokens, "v1/TH/customer-manage/delete/" + this.state.form.customer_id, null));
  };

  Create_Import = async () => {
    loading(true);
    this.afterSave(await POST(tokens, "v1/TH/customer-manage/create/" + getStorage("project_id"), { customer_list: this.state.data_import }));
  };

  clear_form = () => {
    this.setState({
      modal_create: false,
      modal_update: false,
      modal_delete: false,
      modal_import: false,
      page: 1,
      filter_data_search: "",
      filter_transfer_date: "",
      filter_status_transfer: null,
      file_import: null,
      currentSheet: null,
      data_import: null,
      form: { ...initialForm },
    });
  };

  // ---------- นำเข้าไฟล์ ----------

  handleFile = (file) => {
    readFile(file)
      .then((readedData) => {
        // รอ 10ms ให้ ReactExcel อัปเดต currentSheet ก่อนอ่านข้อมูล
        this.setState({ file_import: readedData });
        setTimeout(this.Import, 10);
      })
      .catch(console.error);
  };

  Import = () => {
    const data = generateObjects(this.state.currentSheet)
      .filter((item) => item["ชื่อ - สกุล"])
      .map((item) => ({
        full_name: item["ชื่อ - สกุล"],
        id_card: item["เลขบัตรประชาชน"],
        address: item["ที่อยู่"],
        home_phone: item["โทรศัพท์บ้าน"],
        mobile_phone: item["โทรศัพท์มือถือ"],
        delivery_date: item["วันที่ส่งมอบ"],
        receive_date: item["วันที่มารับมอบ"],
        transfer_date: item["วันที่โอน"],
        status_transfer: TRANSFER_FROM_TEXT[item["สถานะการโอน"]] || null,
        loan_number: item["เลขที่เงินกู้"],
        credit_limit: item["วงเงินกู้"],
        installment: item["เงินงวด"],
        contract_date: item["วันที่ทำสัญญา"],
        status_buy_building: BUY_FROM_TEXT[item["ซื้ออาคารโดย"]] || null,
        address_number: item["บ้านเลขที่"],
        building: item["อาคาร"],
        floor: item["ชั้น"],
        room_size: item["ขนาดห้อง (ตรม.)"],
      }));
    data.shift(); // แถวแรกคือแถวตัวอย่างในไฟล์ template
    this.setState({ data_import: data });
  };

  removeImportRow = (index) => {
    const data = this.state.data_import.filter((_, i) => i !== index);
    this.setState({ data_import: data.length ? data : null });
  };

  // ---------- ฟอร์ม ----------

  // อัปเดตค่าใน form ทีละช่อง
  hForm = (field, val) => this.setState((prev) => ({ form: { ...prev.form, [field]: val } }));

  // ช่องกรอกข้อความ — opts: { req, num, float, max, type }
  // (ช่องที่บังคับกรอกจะแสดง * แดงแทนเครื่องหมาย : ตามดีไซน์เดิมของหน้านี้)
  RInput = (label, field, opts = {}) => (
    <div className="w-100 d-flex align-items-center mb-3">
      <label className="wpx-140">
        {label}
        {opts.req ? required : ":"}
      </label>
      <input
        className={`form-control border-0 bg-contain ${opts.req ? "validate" : ""}`}
        type={opts.type || "text"}
        placeholder="กรอกข้อมูล"
        maxLength={opts.max}
        value={this.state.form[field]}
        onChange={(e) => {
          let val = e.target.value;
          if (opts.num) val = number(val);
          if (opts.float && !float(val) && val !== "") return;
          this.hForm(field, val);
        }}
      />
    </div>
  );

  RDate = (label, field) => (
    <div className="w-100 d-flex align-items-center mb-3">
      <label className="wpx-140">{label}:</label>
      <DatePicker className="form-control bg-contain border-0 w-100" placeholder="พิมพ์คำค้นหา..." value={this.state.form[field]} onChange={(e) => this.hForm(field, e)} />
    </div>
  );

  RSelect = (label, field, options) => (
    <div className="w-100 d-flex align-items-center mb-3">
      <label className="wpx-140">{label}:</label>
      <Select className="form-control bg-contain border-0 select-search" styles={select_style} options={options} value={this.state.form[field]} onChange={(e) => this.hForm(field, e)} />
    </div>
  );

  // เปิดฟอร์มแก้ไข พร้อมแปลงรหัสสถานะกลับเป็น option ของ dropdown
  openUpdate = (item) => {
    this.setState({
      modal_update: true,
      form: {
        ...item,
        status_transfer: STAT_TRANS.find((s) => s.value === item.status_transfer) || null,
        status_buy_building: STAT_BUY.find((s) => s.value === item.status_buy_building) || null,
      },
    });
  };

  render() {
    const { data, filter_data_search, filter_transfer_date, filter_status_transfer, data_import } = this.state;
    const array_data = data?.data || [];

    // ช่องที่ต้องมีค่าในตารางตรวจสอบก่อนนำเข้า — ว่างแล้วไฮไลต์แดง
    const tdRequired = (value, text) => <td className={value ? "text-left" : "bg-danger-light"}>{text ?? (value || "-")}</td>;

    return (
      <div className="w-100 min-vh-100 fade-in">
        <Navbar page1="หน้าหลัก" page2="รายชื่อลูกค้า" />
        <div className="body">
          <div className="p-3">
            <div className="card border-0 p-3">
              {/* หัวข้อ + ปุ่มรายงาน/นำเข้า/เพิ่ม */}
              <div className="d-flex row mx-0 align-items-center justify-content-between">
                <h4 className="mb-3">
                  <b>รายชื่อลูกค้า</b>
                </h4>
                <div className="d-flex row mx-0">
                  <button className="btn btn-outline-primary mx-1 mb-3" onClick={() => report_customer_1(array_data)}>
                    รายงานลูกค้าที่โอนกรรมสิทธิ์
                  </button>
                  <button className="btn btn-outline-primary mx-1 mb-3" onClick={() => report_customer_2(array_data)}>
                    รายงานลูกค้าที่ยังไม่โอน
                  </button>
                  <button className="btn btn-outline-primary mx-1 mb-3" onClick={() => report_customer_3(array_data)}>
                    รายงานห้องว่าง
                  </button>
                  <button
                    className="btn btn-blue px-4 mx-1 text-light mb-3"
                    onClick={() => {
                      this.clear_form();
                      this.setState({ modal_import: true });
                    }}
                  >
                    นำเข้าข้อมูลลูกค้า
                  </button>
                  <button
                    className="btn btn-primary px-4 mx-1 mb-3"
                    onClick={() => {
                      this.clear_form();
                      this.setState({ modal_create: true });
                    }}
                  >
                    เพิ่มข้อมูลลูกค้า
                  </button>
                </div>
              </div>

              {/* ตัวกรอง */}
              <div className="d-flex row mx-0 align-items-center justify-content-between">
                <div className="d-flex row mx-0">
                  <input
                    type="search"
                    className="form-control wpx-200 bg-contain border-0 mx-1 mb-3"
                    placeholder="พิมพ์คำค้นหา..."
                    value={filter_data_search}
                    onKeyUp={(e) => e.key === "Enter" && this.GetAll()}
                    onChange={(e) => this.setState({ filter_data_search: e.target.value })}
                  />
                  <div className="wpx-200 mx-1 mb-3">
                    <DatePicker className="form-control bg-contain border-0" placeholder="พิมพ์คำค้นหา..." value={filter_transfer_date} onChange={(e) => this.setState({ filter_transfer_date: e }, this.GetAll)} />
                  </div>
                  <div className="wpx-200 mx-1 mb-3">
                    <Select className="form-control bg-contain border-0 select-search" styles={select_style} options={STAT_TRANS} isClearable value={filter_status_transfer} onChange={(e) => this.setState({ filter_status_transfer: e }, this.GetAll)} />
                  </div>
                  <button className="btn btn-outline-primary px-3 mb-3" onClick={() => window.location.reload()}>
                    รีเซ็ท
                  </button>
                </div>
              </div>

              {/* ตารางรายชื่อ */}
              <div className="table-responsive">
                <table className="table table-borderless table-striped">
                  <thead>
                    {/* แถวสรุป — ตัวเลข hardcode ตามของเดิม ยังไม่ได้ผูกกับข้อมูลจริง */}
                    <tr>
                      <td className="text-left">
                        <b>หน่วยก่อสร้าง</b>
                      </td>
                      <td className="text-left">1052</td>
                      <td className="text-left">
                        <b>โอนกรรมสิทธิ์แล้ว</b>
                      </td>
                      <td className="text-left">717</td>
                      <td className="text-left">
                        <b>ยังไม่โอน</b>
                      </td>
                      <td className="text-left">335</td>
                      <td className="text-left">
                        <b>ห้องว่าง</b>
                      </td>
                      <td className="text-left">1</td>
                      <td></td>
                    </tr>
                    <tr className="bg-dark-blue text-white">
                      <th className="text-left">อาคาร</th>
                      <th className="text-left">ชั้นที่</th>
                      <th className="text-left">บ้านเลขที่</th>
                      <th className="text-left">ชื่อ - นามสกุล</th>
                      <th className="text-center wpx-150">สถานะ</th>
                      <th className="text-left">วันที่โอน</th>
                      <th className="text-left">โทรศัพท์</th>
                      <th className="text-left">โทรศัพท์มือถือ</th>
                      <th className="text-center">จัดการ</th>
                    </tr>
                  </thead>
                  <tbody>
                    {array_data.length === 0 ? (
                      <tr>
                        <td colSpan={9} className="text-center">
                          ไม่มีข้อมูล
                        </td>
                      </tr>
                    ) : (
                      array_data.map((item, i) => (
                        <tr key={"tr" + i}>
                          <td>{item.building || "-"}</td>
                          <td>{item.floor || "-"}</td>
                          <td>{item.address_number || "-"}</td>
                          <td>{item.full_name || "-"}</td>
                          <td className="text-center">
                            <span className={`${TRANSFER_COLOR[item.status_transfer] || "bg-blue"} rounded px-2 py-1 text-white`}>{labelOf(STAT_TRANS, item.status_transfer)}</span>
                          </td>
                          <td>{item.transfer_date ? format_date(item.transfer_date) : "-"}</td>
                          <td>{item.home_phone || "-"}</td>
                          <td>{item.mobile_phone || "-"}</td>
                          <td className="text-center d-flex justify-content-center">
                            <ActionIcon color="primary" icon={ICON.edit} title="แก้ไข" className="mr-2" onClick={() => this.openUpdate(item)} />
                            <ActionIcon color="danger" icon={ICON.delete} title="ลบ" onClick={() => this.setState({ modal_delete: true, form: { ...this.state.form, customer_id: item.customer_id } })} />
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>

              <Paginate data={data} page={this.state.page} onChange={(v) => this.setState({ page: v }, this.GetAll)} />
            </div>
          </div>
        </div>

        {/* popup เพิ่ม / แก้ไข */}
        <Modal show={this.state.modal_create || this.state.modal_update} onHide={() => this.setState({ modal_create: false, modal_update: false })} dialogClassName="modal-w">
          <Modal.Header>
            <Modal.Title>
              <b>{this.state.modal_create ? "เพิ่มข้อมูลลูกค้า" : "แก้ไขข้อมูลลูกค้า"}</b>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-12 col-lg-6">
                {this.RInput("ชื่อ-นามสกุล", "full_name", { req: true })}
                {this.RInput("เลขบัตรประชาชน", "id_card", { req: true, num: true, max: 13 })}
                {this.RInput("ที่อยู่", "address", { req: true })}
                {this.RInput("ขนาดห้อง (ตรม.)", "room_size", { req: true, float: true, max: 13 })}
                {this.RInput("โทรศัพท์บ้าน", "home_phone", { num: true, max: 10 })}
                {this.RInput("โทรศัพท์มือถือ", "mobile_phone", { req: true, num: true, max: 10 })}
                {this.RDate("วันที่ส่งมอบ", "delivery_date")}
                {this.RDate("วันที่มารับมอบ", "receive_date")}
                {this.RDate("วันที่โอน", "transfer_date")}
              </div>
              <div className="col-12 col-lg-6">
                {this.RSelect("สถานะการโอน", "status_transfer", STAT_TRANS)}
                {this.RInput("เลขที่เงินกู้", "loan_number", { num: true })}
                {this.RInput("วงเงินกู้", "credit_limit", { float: true })}
                {this.RInput("เงินงวด", "installment", { float: true })}
                {this.RDate("วันที่ทำสัญญา", "contract_date")}
                {this.RSelect("ซื้ออาคารโดย", "status_buy_building", STAT_BUY)}
                {this.RInput("อาคาร", "building")}
                {this.RInput("ชั้น", "floor", { num: true })}
                {this.RInput("บ้านเลขที่", "address_number")}
              </div>
            </div>
            <div className="w-100 d-flex">
              <div className="w-50 p-1">
                <button className="btn btn-outline-primary w-100" onClick={() => this.setState({ modal_create: false, modal_update: false })}>
                  ยกเลิก
                </button>
              </div>
              <div className="w-50 p-1">
                <button className="btn btn-primary w-100" onClick={() => (this.state.modal_create ? this.Create() : this.Update())}>
                  {this.state.modal_create ? "เพิ่ม" : "บันทึก"}
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        {/* popup ยืนยันการลบ */}
        <Modal show={this.state.modal_delete} onHide={() => this.setState({ modal_delete: false })}>
          <Modal.Header>
            <Modal.Title>
              <b>ยืนยันการลบข้อมูลลูกค้า</b>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <label className="mb-3">ท่านแน่ใจว่าต้องการลบข้อมูลลูกค้า หลังจากท่านยืนยันการยกเลิกแล้วจะไม่สามารถย้อนคืนข้อมูลได้</label>
            <div className="w-100 d-flex">
              <div className="w-50 p-1">
                <button className="btn btn-outline-primary w-100" onClick={() => this.setState({ modal_delete: false })}>
                  ยกเลิก
                </button>
              </div>
              <div className="w-50 p-1">
                <button className="btn btn-danger w-100" onClick={this.Delete}>
                  ยืนยัน
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        {/* popup นำเข้าข้อมูลลูกค้า */}
        <Modal show={this.state.modal_import} onHide={() => this.setState({ modal_import: false })} dialogClassName="modal-w100">
          <Modal.Header>
            <Modal.Title>
              <b>นำเข้าข้อมูลลูกค้า</b>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {!data_import ? (
              <ExcelDropZone
                templateFile={excel_file}
                templateName="import_customer.xlsx"
                templateLabel="template นำเข้าข้อมูลลูกค้า"
                linkClassName="text-secondary text-decoration-none mt-3"
                onFile={this.handleFile}
              />
            ) : (
              <div className="table-responsive" style={{ height: "80vh", maxHeight: "80vh" }}>
                <table className="table table-borderless table-striped">
                  <thead>
                    <tr className="bg-dark-blue text-white">
                      {PREVIEW_HEADERS.map((th, i) => (
                        <th key={i} className="text-left">
                          {th}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {data_import.map((item, index) => (
                      <tr key={"tr" + index}>
                        {tdRequired(item.full_name)}
                        {tdRequired(item.id_card)}
                        {tdRequired(item.address)}
                        <td>{item.home_phone || "-"}</td>
                        {tdRequired(item.mobile_phone)}
                        <td>{item.delivery_date || "-"}</td>
                        <td>{item.receive_date || "-"}</td>
                        <td>{item.transfer_date || "-"}</td>
                        {tdRequired(item.status_transfer, labelOf(STAT_TRANS, item.status_transfer))}
                        <td>{item.loan_number || "-"}</td>
                        <td>{item.credit_limit || "-"}</td>
                        <td>{item.installment || "-"}</td>
                        <td>{item.contract_date || "-"}</td>
                        {tdRequired(item.status_buy_building, labelOf(STAT_BUY, item.status_buy_building))}
                        {tdRequired(item.address_number)}
                        {tdRequired(item.building)}
                        {tdRequired(item.floor)}
                        {tdRequired(item.room_size)}
                        <td>
                          <ActionIcon color="danger" icon={ICON.delete} title="ลบแถวนี้" onClick={() => this.removeImportRow(index)} />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            {/* ตัวแปลงไฟล์ Excel ของ library — ซ่อนไว้ */}
            <div className="d-none">
              <ReactExcel initialData={this.state.file_import} onSheetUpdate={(s) => this.setState({ currentSheet: s })} activeSheetClassName="d-none" reactExcelClassName="table table-borderless table-striped" />
            </div>

            <div className="w-100 d-flex mt-3">
              {!data_import ? (
                <button className="btn btn-outline-primary w-100" onClick={() => this.setState({ modal_import: false })}>
                  ปิดหน้าต่าง
                </button>
              ) : (
                <>
                  <div className="p-1 w-33">
                    <button className="btn btn-outline-primary w-100" onClick={() => this.setState({ modal_import: false })}>
                      ยกเลิก
                    </button>
                  </div>
                  <div className="p-1 w-33">
                    <button className="btn btn-danger w-100" onClick={() => this.setState({ data_import: null })}>
                      ล้างค่า
                    </button>
                  </div>
                  <div className="p-1 w-33">
                    <button className="btn btn-primary w-100" onClick={this.Create_Import}>
                      นำเข้า
                    </button>
                  </div>
                </>
              )}
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}
